import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=4eb2867c&scoped=true&"
import script from "@/scripts/TrainingCamp/TrainingCamp/components/TaskItem.js?vue&type=script&lang=js&"
export * from "@/scripts/TrainingCamp/TrainingCamp/components/TaskItem.js?vue&type=script&lang=js&"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=4eb2867c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb2867c",
  null
  
)

export default component.exports